import React, { useEffect, useState } from 'react';
import { Route, Redirect } from 'react-router-dom';
import Loader from '../../components/Loader';
import { useUser } from '../../context/user';


export default function PrivateRoute(props) {
  const { user, isLoading } = useUser();
  const { component: Component, ...rest } = props;
  const [userIsFetched, setUserIsFetched] = useState(false);

  useEffect(() => {
    // used to delay 1 cycle in order for fetchUser to be initiated
    setUserIsFetched(true);
  }, []);

  if (isLoading || !userIsFetched) {
    return <Loader />;
  }

  return (
    <Route
      {...rest}
      render={(props) =>
        user ? (
          <Component {...props} />
        ) : (
          <Redirect
            to={{
              pathname: '/login',
              state: { from: props.location },
            }}
          />
        )
      }
    />
  );
}
